import React from 'react';
import blogCover from '../images/news5.jpeg';
import OurPartner from '../pages/components/OurPartner';

function CustomERPSolutions() {
    return (
        <>
            {/* BLOG TITLE */}
            <section className="container my-5">
                <div className="text-center">
                    <h1 className="fw-bold responsive-heading">
                        <span className="highlight-orange">
                            How a Custom ERP Can Save Your Operations Team 20+ Hours a Week
                        </span>
                    </h1>

                    <p className="mt-3 text-muted fs-5">
                        Discover how custom ERP solutions can streamline operations and save
                        valuable time for your team.
                    </p>
                </div>
            </section>

            {/* BLOG COVER IMAGE */}
            <section className="container my-4">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-7">
                        <img
                            src={blogCover}
                            alt="Custom ERP Solutions"
                            className="img-fluid rounded shadow w-100"
                        />
                    </div>
                </div>
            </section>

            {/* BLOG CONTENT */}
            <section className="container my-5">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-9">

                        {/* INTRODUCTION */}
                        <p className="mb-4">
                            Operations teams are often buried under manual processes,
                            disconnected tools, and repetitive data entry. From inventory and
                            procurement to finance and reporting, valuable hours are lost every
                            week managing systems that were never designed to work together.
                        </p>

                        <p className="mb-4">
                            A <strong>custom ERP solution</strong> solves this problem by
                            centralizing business operations into a single, tailored platform —
                            helping teams work faster, smarter, and with greater visibility.
                        </p>

                        {/* SECTION 1 */}
                        <h2 className="fw-bold mb-3">
                            <span className="highlight-orange">
                                What Is a Custom ERP Solution?
                            </span>
                        </h2>

                        <p className="mb-3">
                            A custom ERP (Enterprise Resource Planning) system is a software
                            platform designed specifically around your business workflows,
                            processes, and operational requirements.
                        </p>

                        <p className="mb-4">
                            Unlike off-the-shelf ERP products, custom ERP solutions adapt to
                            your organization — not the other way around — eliminating
                            unnecessary features while enhancing critical workflows.
                        </p>

                        {/* SECTION 2 */}
                        <h2 className="fw-bold mb-3">
                            <span className="highlight-orange">
                                Where Operations Teams Lose Time
                            </span>
                        </h2>

                        <p className="mb-3">
                            Operations teams often spend hours switching between systems,
                            reconciling data, generating reports, and following up on manual
                            approvals.
                        </p>

                        <p className="mb-4">
                            These inefficiencies not only slow down daily work but also
                            increase errors, reduce accountability, and limit operational
                            visibility.
                        </p>

                        {/* KEY BENEFITS */}
                        <h4 className="fw-bold highlight-orange mb-2">
                            How a Custom ERP Saves 20+ Hours Weekly
                        </h4>

                        <ul className="ps-3 mb-4">
                            <li className="mb-1">Automated workflows and approvals</li>
                            <li className="mb-1">Single source of truth for all departments</li>
                            <li className="mb-1">Real-time dashboards and reports</li>
                            <li className="mb-1">Reduced manual data entry and duplication</li>
                        </ul>

                        {/* SECTION 3 */}
                        <h2 className="fw-bold mb-3">
                            <span className="highlight-orange">
                                Better Visibility and Faster Decisions
                            </span>
                        </h2>

                        <p className="mb-3">
                            With a custom ERP, leaders gain instant access to accurate,
                            real-time data across departments. This eliminates guesswork and
                            speeds up decision-making.
                        </p>

                        <p className="mb-4">
                            Operations teams can track performance, identify bottlenecks, and
                            optimize workflows before issues escalate.
                        </p>

                        {/* SECTION 4 */}
                        <h2 className="fw-bold mb-3">
                            <span className="highlight-orange">
                                Scalability Without Complexity
                            </span>
                        </h2>

                        <p className="mb-3">
                            As businesses grow, operational complexity increases. Custom ERP
                            solutions are built to scale with your organization, supporting
                            new teams, locations, and processes.
                        </p>

                        <p className="mb-4">
                            Instead of adding more tools, your ERP evolves alongside your
                            business — maintaining simplicity and efficiency.
                        </p>

                        {/* CONCLUSION */}
                        <h2 className="fw-bold mb-3">
                            <span className="highlight-orange">
                                Final Thoughts
                            </span>
                        </h2>

                        <p className="mb-4">
                            A custom ERP is more than just software — it is a productivity
                            engine for your operations team. By eliminating inefficiencies and
                            automating workflows, businesses can save 20+ hours per week while
                            improving accuracy and control.
                        </p>

                        <p className="mb-4">
                            If your operations team is struggling with manual processes and
                            fragmented systems, investing in a custom ERP could be the
                            smartest move you make.
                        </p>

                        {/* CTA */}
                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold mt-3"
                            style={{ width: 'fit-content' }}
                        >
                            Build Your Custom ERP Solution
                        </a>

                    </div>
                </div>
            </section>

            <OurPartner />
        </>
    );
}

export default CustomERPSolutions;
